import { Box, Typography } from '@mui/material';
import { useAtomValue } from 'jotai';
import { get } from 'lodash';
import { Link } from 'react-router';

import KeyValueResponsive from '@/components/KeyValueResponsive';
import type { KeyValueResponsiveModel } from '@/components/KeyValueResponsive/KeyValueResponsive.types';
import { LargeCard } from '@/components/LargeCard';
import PonduranceLinkButton from '@/components/PonduranceLinkButton';
import { caseDetailsAtom } from '@/pages/Case/Case.store';
import type { CaseAlertData } from '@/pages/Case/Case.types';

import useStyles from './CaseAlertDetails.styles';

const CaseAlertDetails = () => {
  const caseDetails = useAtomValue(caseDetailsAtom);
  const { classes } = useStyles();

  const alertData = get(
    caseDetails,
    'raw_data.alert_data.raw-alert',
    {}
  ) as CaseAlertData;

  const kvItems: KeyValueResponsiveModel[] = [
    {
      label: 'Alert Vendor',
      value: alertData?.alertVendor || '--'
    },
    {
      label: 'Alert Product',
      value: alertData?.alertProduct || '--'
    },
    {
      label: 'Repository',
      value: alertData?.repository || '--'
    },
    {
      label: 'Logscale Link',
      value: <PonduranceLinkButton url={alertData?.linkURL || ''} />
    }
  ];

  return (
    <LargeCard title="Alert Details" className={classes.caseAlertDetails}>
      <Typography sx={{ fontSize: '0.75rem' }} color="textSecondary">
        Alert Name
      </Typography>
      <Box sx={{ mb: 2, fontWeight: 'bold' }}>
        <Link to={`/alert-rules?alertRule=${alertData?.alertId}`}>
          {alertData?.alertName || '--'}
        </Link>
      </Box>

      <KeyValueResponsive items={kvItems} />

      <Typography sx={{ fontSize: '0.75rem' }} color="textSecondary">
        Alert ID
      </Typography>
      <Box sx={{ mb: 2 }}>
        <b>{alertData?.alertId || '--'}</b>
      </Box>

      <Typography sx={{ fontSize: '0.75rem' }} color="textSecondary">
        Alert Description
      </Typography>
      <Box sx={{ mb: 2, whiteSpace: 'pre-wrap' }}>
        {alertData?.alertDescription || '--'}
      </Box>
    </LargeCard>
  );
};

export default CaseAlertDetails;
